/* LABOSCH V49 — responsive interaction controller (<=1024px only). */
(function(){
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 1024px)') : {matches:false};
  if(!mq.matches) return;

  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function setViewport(){
    var h = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.documentElement.style.setProperty('--lbx49-vh', Math.max(320, Number(h)||0) + 'px');
  }

  function isOpen(el){
    if(!el || el.hidden) return false;
    if(el.getAttribute('aria-hidden') === 'true') return false;
    if(el.matches('[data-mg2-mobile-drawer]')) return el.classList.contains('is-open') || el.getAttribute('aria-hidden') === 'false';
    if(el.matches('[data-mg2-search-overlay]')) return el.classList.contains('is-open') || el.getAttribute('aria-hidden') === 'false';
    if(el.matches('.lbxv5-filters')) return el.classList.contains('is-open') || el.getAttribute('aria-hidden') === 'false';
    return true;
  }

  function syncLock(){
    var selectors = [
      '[data-mg2-mobile-drawer]','[data-mg2-search-overlay]','.lbxv5-filters',
      '[data-lbx-size-guide-modal]','[data-lbx-description-modal]','[data-lbx-story-modal]',
      '[data-lbx-preorder-modal]','[data-lbx-wishlist-modal]'
    ].join(',');
    var open = qa(selectors).some(isOpen);
    document.documentElement.classList.toggle('v48-lock', open);
    document.body.classList.toggle('v48-lock', open);
    document.documentElement.classList.toggle('lbx49-lock', open);
    document.body.classList.toggle('lbx49-lock', open);

    var filters = q('.lbxv5-filters');
    var backdrop = q('.lbxv5-filter-backdrop');
    if(backdrop) backdrop.classList.toggle('is-open', !!(filters && isOpen(filters)));
  }

  function initOverlayObserver(){
    var els = qa('[data-mg2-mobile-drawer],[data-mg2-search-overlay],.lbxv5-filters,[data-lbx-size-guide-modal],[data-lbx-description-modal],[data-lbx-story-modal],[data-lbx-preorder-modal],[data-lbx-wishlist-modal]');
    if(!els.length) return;
    var obs = new MutationObserver(syncLock);
    els.forEach(function(el){ obs.observe(el,{attributes:true,attributeFilter:['hidden','aria-hidden','class','style']}); });
    syncLock();
  }

  function initDrawer(){
    var drawer = q('[data-mg2-mobile-drawer]');
    if(!drawer || drawer.dataset.v49Init === '1') return;
    drawer.dataset.v49Init = '1';

    drawer.addEventListener('toggle', function(e){
      var detail = e.target;
      if(!detail || detail.tagName !== 'DETAILS' || !detail.open) return;
      qa('details', drawer).forEach(function(other){
        if(other !== detail && other.parentElement === detail.parentElement) other.open = false;
      });
    }, true);

    drawer.addEventListener('click', function(e){
      var link = e.target.closest('a[href]');
      if(!link) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      syncLock();
    });
  }

  function initFilters(){
    var panel = q('.lbxv5-filters,[data-lbx-filter-panel]');
    if(!panel || panel.dataset.v49Init === '1') return;
    panel.dataset.v49Init = '1';
    var openers = qa('[data-lbx-open-filters],.lbxv5-toolbar__filter');
    var closers = qa('[data-lbx-close-filters],.lbxv5-filters__head button', panel);
    var backdrop = q('.lbxv5-filter-backdrop');

    function focusClose(){ var el = closers[0]; if(el) setTimeout(function(){ el.focus(); },30); }
    openers.forEach(function(btn){ btn.addEventListener('click', function(){ focusClose(); setTimeout(syncLock,0); }); });
    closers.forEach(function(btn){ btn.addEventListener('click', function(){ setTimeout(function(){ if(openers[0]) openers[0].focus(); syncLock(); },10); }); });
    if(backdrop) backdrop.addEventListener('click', function(){
      panel.classList.remove('is-open'); panel.setAttribute('aria-hidden','true'); syncLock();
    });
  }

  function initFinanceClosed(root){
    qa('[data-lbx-finance-card]', root || document).forEach(function(card){
      if(card.dataset.v49FinanceInit === '1') return;
      card.dataset.v49FinanceInit = '1';
      var controls = q('[data-lbx-finance-controls]', card);
      var toggle = q('[data-lbx-finance-toggle]', card);
      if(controls) controls.hidden = true;
      if(toggle) toggle.setAttribute('aria-expanded','false');
      card.classList.remove('is-open');
    });
  }

  function initModalFocus(){
    qa('[data-lbx-size-guide-modal],[data-lbx-description-modal],[data-lbx-story-modal]').forEach(function(modal){
      if(modal.dataset.v49Focus === '1') return;
      modal.dataset.v49Focus = '1';
      var obs = new MutationObserver(function(){
        if(isOpen(modal)){
          var close = q('[data-lbx-size-guide-close],[data-lbx-description-close],[data-lbx-story-close]', modal);
          if(close) setTimeout(function(){ close.focus({preventScroll:true}); },20);
        }
      });
      obs.observe(modal,{attributes:true,attributeFilter:['hidden','aria-hidden','class']});
    });
  }

  function normalizeProductGallery(){
    var img = q('[data-lbx-main-image]');
    if(!img) return;
    img.removeAttribute('style');
    img.setAttribute('decoding','async');
    /* Featured image stays eager, but variant/gallery swaps should not force layout shifts. */
    var wrap = q('[data-lbx-main-image-wrap]');
    if(wrap) wrap.style.removeProperty('height');
  }

  function boot(scope){
    setViewport();
    initDrawer();
    initFilters();
    initFinanceClosed(scope || document);
    initModalFocus();
    normalizeProductGallery();
    initOverlayObserver();
    document.documentElement.classList.add('v49-responsive-ready');
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(document); }, {once:true});
  else boot(document);

  document.addEventListener('shopify:section:load', function(e){ boot(e.target || document); });
  window.addEventListener('orientationchange', function(){ setTimeout(setViewport,80); }, {passive:true});
  if(window.visualViewport) window.visualViewport.addEventListener('resize', setViewport, {passive:true});
  window.addEventListener('pageshow', function(){ initFinanceClosed(document); syncLock(); }, {passive:true});
})();
